module.exports = __webpack_public_path__ + "static/media/Mask-Group-41.ca8be5b1.svg";